
import {
    CENTER_MAP_ON_CAR,
    CLEAR_TRACKING_VEHICLES, SET_ACTIVE_JOURNEY,
    SET_DEVICES_INACTIVE,
    SET_DEVICES_OFFLINE,
    SET_DEVICES_ONLINE,
    SET_IS_JOURNEY_LOADING,
    SUBSCRIBE_TRACKING_VEHICLE,
    UNSUBSCRIBE_TRACKING_VEHICLE,
    UPDATE_FILTERS,
    SET_DEVICE_STATISTICS,
    SUBSCRIBE_JOURNEY_VEHICLE,
    UNSUBSCRIBE_JOURNEY_VEHICLE,
    SET_IS_TRACKING_ASIDE_LOADING,
    CLEAR_SUBSCRIBE_JOURNEY_VEHICLES,
    ADD_ACTIVE_JOURNEY,
    REMOVE_ACTIVE_JOURNEY,
    CLEAR_ACTIVE_JOURNEYS,
    SET_CURRENT_JOURNEY,
    UPDATE_CURRENT_JOURNEY_MEDIA,
    SET_CURRENT_VEHICLE,
    ADD_SELECTED_JOURNEY,
    REMOVE_SELECTED_JOURNEY,
    CLEAR_SELECTED_JOURNEY,
    SET_SHOW_IDLE_POINTS,
    SET_SHOW_RAW_DATA,
    SET_EVENT_FILTERS,
    SET_EVENT_CLASSIFICATION,
    SET_LOADING,
    SET_IS_JOURNEY_TAB_ACTIVE,
    SET_OPEN_AUTO_JOURNEY,
    SET_DATE_IN_JOURNEY_TAB,
    SET_SHOW_SPEEDING_DATA,
    SET_UPDATE_SHARED_EVENT,
    UPDATE_SUBSCRIBED_VEHICLES_POSITIONS,
    SET_IS_CLUSTERING_ACTIVE,
    SET_IS_OPEN_ACTION_JOURNEY_TAB,
    SET_LAST_ACTIVE_DATE
} from '@/store/modules/tracking/mutations'

const setDeviceSummary = ({ commit }, payload) => {
    commit(SET_DEVICES_INACTIVE, payload.devicesInactive)
    commit(SET_DEVICES_OFFLINE, payload.devicesOffline)
    commit(SET_DEVICES_ONLINE, payload.devicesOnline)
}

const subscribeTrackingVehicle = ({ commit }, payload) => {
    if (process.env.VUE_APP_DEBUG) {
        console.debug('subscribeTrackingVehicle', payload)
    }

    commit(SUBSCRIBE_TRACKING_VEHICLE, payload)
}

const unsubscribeTrackingVehicle = ({ commit }, payload) => {
    commit(UNSUBSCRIBE_TRACKING_VEHICLE, payload)
}

const clearTrackingVehicles = ({ commit }) => {
    commit(CLEAR_TRACKING_VEHICLES)
}

const updateFilters = ({ commit }, payload) => {
    commit(UPDATE_FILTERS, payload)
}

const centerMapOnCar = ({ commit }, payload) => {
    commit(CENTER_MAP_ON_CAR, payload)
}

const setActiveJourney = ({ commit }, payload) => {
    commit(SET_ACTIVE_JOURNEY, payload)
}

const setIsJourneyLoading = ({ commit }, payload) => {
    commit(SET_IS_JOURNEY_LOADING, payload)
}

const setDeviceStatistics = ({ commit }, payload) => {
    commit(SET_DEVICE_STATISTICS, payload)
}

const subscribeJourneyVehicle = ({ commit }, payload) => {
    commit(SUBSCRIBE_JOURNEY_VEHICLE, payload)
    commit(SET_CURRENT_VEHICLE, payload)
}

const unsubscribeJourneyVehicle = ({ commit }, payload) => {
    commit(UNSUBSCRIBE_JOURNEY_VEHICLE, payload)
}

const clearSubscriptionJourneyVehicle = ({ commit }) => {
    commit(CLEAR_SUBSCRIBE_JOURNEY_VEHICLES)
}

const addActiveJourney = ({ commit }, payload) => {
    commit(ADD_ACTIVE_JOURNEY, payload)
}
const removeActiveJourney = ({ commit }, payload) => {
    commit(REMOVE_ACTIVE_JOURNEY, payload)
}
const clearActiveJourneys = ({ commit }, payload) => {
    commit(CLEAR_ACTIVE_JOURNEYS, payload)
}

const setCurrentJourney = ({ commit }, payload) => {
    if (process.env.VUE_APP_DEBUG) {
        console.debug('setCurrentJourney', payload)
    }

    commit(SET_CURRENT_JOURNEY, payload)
}

const updateCurrentJourneyMedia = ({ commit }, payload) => {
    commit(UPDATE_CURRENT_JOURNEY_MEDIA, payload)
}

const setCurrentVehicle = ({ commit }, payload) => {
    if (process.env.VUE_APP_DEBUG) {
        console.debug('setCurrentVehicle', payload)
    }

    commit(SET_CURRENT_VEHICLE, payload)
}

const addSelectedJourney = ({ commit }, payload) => {
    commit(ADD_SELECTED_JOURNEY, payload)
}
const removeSelectedJourney = ({ commit }, payload) => {
    commit(REMOVE_SELECTED_JOURNEY, payload)
}

const clearSelectedJourneys = ({ commit }, payload) => {
    commit(CLEAR_SELECTED_JOURNEY, payload)
}

const setShowIdlePoints = ({ commit }, payload) => {
    commit(SET_SHOW_IDLE_POINTS, payload)
}

const setShowRawData = ({ commit }, payload) => {
    commit(SET_SHOW_RAW_DATA, payload)
}

const setShowSpeedingData = ({ commit }, payload) => {
    commit(SET_SHOW_SPEEDING_DATA, payload)
}

const setEventFilters = ({ commit }, payload) => {
    commit(SET_EVENT_FILTERS, payload)
}

const setEventClassification = ({ commit }, payload) => {
    commit(SET_EVENT_CLASSIFICATION, payload)
}

const setLoading = ({ commit }, payload) => {
    commit(SET_LOADING, payload)
}

const setIsTrackingAsideLoading = ({ commit }, payload) => {
    commit(SET_IS_TRACKING_ASIDE_LOADING, payload)
}

const setIsJourneyTabActive = ({ commit }, payload) => {
    commit(SET_IS_JOURNEY_TAB_ACTIVE, payload)
}

const setOpenAutoJourney = ({ commit }, payload) => {
    commit(SET_OPEN_AUTO_JOURNEY, payload)
}

const setDateInJourneyTab = ({ commit }, payload) => {
    commit(SET_DATE_IN_JOURNEY_TAB, payload)
}

const setUpdateSharedEvent = ({ commit }, payload) => {
    commit(SET_UPDATE_SHARED_EVENT, payload)
}

const updateSubscribedVehiclesPositions = ({ commit }, payload) => {
    commit(UPDATE_SUBSCRIBED_VEHICLES_POSITIONS, payload)
}

const setIsClusteringActive = ({ commit }, payload) => {
    commit(SET_IS_CLUSTERING_ACTIVE, payload)
}

const setIsOpenActionJourneyTab = ({ commit }, payload) => {
    commit(SET_IS_OPEN_ACTION_JOURNEY_TAB, payload)
}

const setLastActiveDate = ({ commit }, payload) => {
    commit(SET_LAST_ACTIVE_DATE, payload)
}

export default {
    setDeviceSummary,
    subscribeTrackingVehicle,
    unsubscribeTrackingVehicle,
    clearTrackingVehicles,
    updateFilters,
    centerMapOnCar,
    setActiveJourney,
    setIsJourneyLoading,
    setDeviceStatistics,
    subscribeJourneyVehicle,
    unsubscribeJourneyVehicle,
    clearSubscriptionJourneyVehicle,
    addActiveJourney,
    removeActiveJourney,
    clearActiveJourneys,
    setCurrentJourney,
    updateCurrentJourneyMedia,
    setCurrentVehicle,
    addSelectedJourney,
    removeSelectedJourney,
    clearSelectedJourneys,
    setShowIdlePoints,
    setShowRawData,
    setEventFilters,
    setEventClassification,
    setLoading,
    setIsTrackingAsideLoading,
    setIsJourneyTabActive,
    setOpenAutoJourney,
    setDateInJourneyTab,
    setShowSpeedingData,
    setUpdateSharedEvent,
    updateSubscribedVehiclesPositions,
    setIsClusteringActive,
    setIsOpenActionJourneyTab,
    setLastActiveDate
}
